import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['zone', 'input', 'filename', 'filesize', 'fileInfo'];

  declare readonly zoneTarget: HTMLElement;
  declare readonly inputTarget: HTMLInputElement;
  declare readonly filenameTarget: HTMLElement;
  declare readonly filesizeTarget: HTMLElement;
  declare readonly fileInfoTarget: HTMLElement;

  browse() {
    this.inputTarget.click();
  }

  dragOver(event: DragEvent) {
    event.preventDefault();
    this.zoneTarget.classList.add('toolkit-drop-zone-component__zone--active');
  }

  dragLeave(event: DragEvent) {
    event.preventDefault();
    this.zoneTarget.classList.remove('toolkit-drop-zone-component__zone--active');
  }

  drop(event: DragEvent) {
    event.preventDefault();
    this.zoneTarget.classList.remove('toolkit-drop-zone-component__zone--active');

    const files = event.dataTransfer?.files;
    if (files && files.length > 0) {
      this.inputTarget.files = files;
      this.showFile(files[0]);
      this.inputTarget.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  fileSelected() {
    const files = this.inputTarget.files;
    if (files && files.length > 0) {
      this.showFile(files[0]);
    }
  }

  removeFile(event: Event) {
    event.stopPropagation();
    this.inputTarget.value = '';
    this.hideFile();
  }

  private showFile(file: File) {
    this.filenameTarget.textContent = file.name;
    this.filesizeTarget.textContent = this.formatSize(file.size);
    this.fileInfoTarget.classList.add('toolkit-drop-zone-component__file-info--visible');
    this.zoneTarget.classList.add('toolkit-drop-zone-component__zone--has-file');
  }

  private hideFile() {
    this.filenameTarget.textContent = '';
    this.filesizeTarget.textContent = '';
    this.fileInfoTarget.classList.remove('toolkit-drop-zone-component__file-info--visible');
    this.zoneTarget.classList.remove('toolkit-drop-zone-component__zone--has-file');
  }

  private formatSize(bytes: number): string {
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1048576) return `${(bytes / 1024).toFixed(1)} KB`;
    return `${(bytes / 1048576).toFixed(1)} MB`;
  }
}
